var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.7C21.1797 22.7 27 17.8423 27 11.85C27 5.85771 21.1797 1 14 1C6.8203 1 1 5.85771 1 11.85C1 17.8423 6.8203 22.7 14 22.7Z",
    stroke: "#6B6B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.85C14 10.2057 14.6848 8.62869 15.9038 7.46596C17.1228 6.30324 18.7761 5.65002 20.5 5.65002C22.2239 5.65002 23.8772 6.30324 25.0962 7.46596C26.3152 8.62869 27 10.2057 27 11.85V30.45H20.5C9.775 30.45 1 22.08 1 11.85C1 10.2057 1.68482 8.62869 2.90381 7.46596C4.12279 6.30324 5.77609 5.65002 7.5 5.65002C9.22391 5.65002 10.8772 6.30324 12.0962 7.46596C13.3152 8.62869 14 10.2057 14 11.85ZM14 11.85V13.4M7.5 11.85H7.51625M20.5 11.85H20.5163",
    stroke: "#6B6B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.45C25.3192 30.45 23.7072 29.8131 22.5187 28.6794C21.3302 27.5458 20.6625 26.0082 20.6625 24.405C20.6625 22.8018 21.3302 21.2642 22.5187 20.1305C23.7072 18.9969 25.3192 18.36 27 18.36M10.75 27.97V32M17.25 30.2175V32",
    stroke: "#6B6B84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwl);
export default __webpack_public_path__ + "static/media/owl.af1fb5f7f1e07982467af19b7697fc5d.svg";
export { ForwardRef as ReactComponent };